import React from "react";
import validate from "./validation";
import "./Email.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import String from "../../../../Assets/Localization/local";
import { MyTicket_PATH } from "../../../../AppConfig";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import RenderField from "../../../../Components/Fields/fields";
import { forgetPassword } from "../../../../Redux/Action/ForgetAction";
import logoPart1 from "../../../../Assets/Images/logoWihte.png";
import LoadingBar from "react-redux-loading-bar";

import { Row, Col, Form, FormGroup } from "reactstrap";
class Email extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedOption: "ADMIN",
    };
    this.radioChange = this.radioChange.bind(this);
  }
  radioChange(e) {
    this.setState({
      selectedOption: e.currentTarget.value,
    });
  }

  onSubmit = (values) => {
    values.type = "OTHER";
    this.props.forgetPassword(values, this.props.lang);
  };

  render() {
    const { handleSubmit } = this.props;
    String.setLanguage(this.props.lang);
    if (this.props.page === "ConfirmCode") {
      return (
        <Redirect
          to={{
            pathname: `${MyTicket_PATH}MyticketCinema/ConfirmCode`,
            state: {
              type: this.props.location.state.type,
            },
          }}
        />
      );
    }
    console.log("Typeeeeeee:", this.props.location.state.type);
    return (
      <div
        className="loginClass"
        style={{ textAlign: "center", color: "white" }}
      >
        <div className="loginClass-2">
          <div className="loading-bar">
            <LoadingBar
              style={{
                height: "3px",
                zIndex: 1250,
                backgroundImage: `linear-gradient(to right, #FF5438, #FF8044)`,
              }}
            />
          </div>
          <div className="OverLay">
            <div className="LoginContainer">
              <div className="LoginForm">
                <img
                  alt="part_two"
                  src={logoPart1}
                  className="img-fluid LogoPartt2Login"
                  style={{ width: "60px", height: "60px" }}
                />
              
                <Form
                  onSubmit={handleSubmit(this.onSubmit.bind(this))}
                  className="FormContent"
                  id="email-confirm"
                >
                  {/* <input type="email" name="Email" placeholder={String.EnterMail} /> */}
                  <Field
                    component={RenderField}
                    type="email"
                    name="email"
                    lang={this.props.lang}
                    icone="fa fa-user"
                    placeholder={
                      this.props.lang === "ar"
                        ? "البريد الالكتروني"
                        : "enter email"
                    }
                    loginBool="true"
                  />
                 <button type="submit" value="Login" className="loginBtn px-5">
                    {String.SendKey}{" "}
                  </button>
                  <Link
                    to={"/MyticketCinema/login"}
                    className="BackLink"
                    style={{ textDecoration: "underline" }}
                  >
                    {String.BackBtn}
                  </Link>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.userInfo.language,
    token: state.userInfo.token,
    page: state.forgetPass.page,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      forgetPassword,
    },
    dispatch
  );

export default reduxForm({
  form: "Email",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(Email));
